import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiceLocatorService, EventService } from '@ncs/ncs-lib';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root',
})
export class SharedataService {
  private subject = new Subject<any>();
  private subjectAnother = new Subject<any>();
  public dataOne: any = {};

  public data: any;
  public keySuffix: string = '';

  private storedFunctions = new BehaviorSubject<Map<string, Function>>(
    new Map()
  );

  constructor(
    public locator: ServiceLocatorService,
    private eService: EventService,
    public route: ActivatedRoute
  ) {
    this.locator.config.getProperty('CONTEXT_PATH').then((property: string) => {
      this.keySuffix = property + '-';
    });
  }

  private secretKey = 'your-very-secure-key';

  encrypt(data: any): any {
    return CryptoJS.AES.encrypt(data, this.secretKey).toString();
  }

  decrypt(ciphertext: any): any {
    try {
      const bytes = CryptoJS.AES.decrypt(ciphertext, this.secretKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return '';
    }
  }

  setFunction(key: string, fn: Function): void {
    const currentFunctions = this.storedFunctions.getValue();
    currentFunctions.set(key, fn);
    this.storedFunctions.next(currentFunctions);
  }

  getFunction(key: string): Function | undefined {
    const currentFunctions = this.storedFunctions.getValue();
      return currentFunctions.get(key);
  }

  changeTheme() {
    const isDarkMode = localStorage.getItem(
      localStorage.getItem('keySuffix') + 'theme'
    );

    const fn = this.getFunction('toggle');
    if (fn) {
      fn(isDarkMode);
    } else {
      // console.warn('No function found for key "toggle"');
    }
  }

  getKeySuffix() {
    return this.keySuffix;
  }

  sendData(data: any) {
    this.subject.next({ data: data });
    this.data = data;
  }

  getData(): Observable<any> {
    return this.subject.asObservable();
  }

  getData1(): any {
    return this.data;
  }

  updateSharedData(key: string, value: any) {
    this.dataOne[key] = value;
    this.subjectAnother.next(this.dataOne);
  }

  getSharedData(): Observable<any> {
    return this.subjectAnother.asObservable();
  }
}
